var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-navigation-step",class:{ 'px-navigation-step--active': _vm.active },style:({ backgroundColor: _vm.color }),on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }